'use client';
import React, { createContext, useContext, useState } from 'react';

type FrontPageEffectContextValue = {
  videoLoaded: boolean;
  setVideoLoaded: (value: boolean) => void;
};

const FrontPageEffectContext =
  createContext<FrontPageEffectContextValue | null>(null);

export const FrontPageEffectProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <FrontPageEffectContext.Provider value={{ videoLoaded, setVideoLoaded }}>
      {children}
    </FrontPageEffectContext.Provider>
  );
};

export const useFrontPageEffect = () => {
  const ctx = useContext(FrontPageEffectContext);
  if (!ctx)
    throw new Error(
      'useFrontPageEffect must be used inside FrontPageEffectProvider'
    );
  return ctx;
};
